import { getDatasource, getGlobals } from "storyblok/api"
import { getCategoryBlogArticles, getAllBlogCategoryPaths } from "storyblok/blog"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import BlogCard from "components/BlogCard"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import Meta from "components/Meta"
import { getCategoryBlogArticlesApi } from "storyblok/blogApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function BlogCategory({ items, perPage, total, currentPage, category, categories }) {
  return (
    <>
      <Meta info={{ title: `${category.name}`, og_title: `${category.name}`, twitter_title: `${category.name}` }} />
      <PageHeader
        blok={{
          type: "standard",
          image: {},
          heading: category.name,
          breadcrumbs: [{ text: "Personal Injury Blog", href: "/blog" }, { text: category.name }],
        }}
      />
      <CategoryArchiveSection
        categories={categories}
        archiveLink="/blog"
        categoryLinkPrefix="/blog/category/"
        currentTab={category}
        list={<CardListSection
          key={category.value}
          items={items}
          total={total}
          perPage={perPage}
          currentPage={currentPage}
          columns={4}
          category={category.value}
          handler={(params) => getCategoryBlogArticlesApi(params)}
          Card={BlogCard} />}
      />
    </>
  )
}

export async function getStaticProps({ params: { category } }) {
  const globals = await getGlobals()
  const categories = await getDatasource("blog-categories")
  const { items, perPage, total, currentPage } = await getCategoryBlogArticles({ category })

  return {
    props: {
      category: { name: category.replaceAll("-", " "), value: category },
      categories,
      globals: globals ?? null,
      items,
      perPage,
      total,
      currentPage
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllBlogCategoryPaths(),
    fallback: false,
  }
}
